import { create } from "zustand";

import type {
  SettingsPanelDetailView,
  SettingsPanelView,
} from "./SettingsPanel/types";

const ROOT_VIEW_STACK: SettingsPanelView[] = [{ type: "main" }];

interface SettingsPanelStore {
  back: () => void;
  close: () => void;
  hasUnsavedSnippet: boolean;
  isCreatingCustomFiles: boolean;
  isOpen: boolean;
  open: () => void;
  push: (view: SettingsPanelDetailView) => void;
  replace: (view: SettingsPanelDetailView) => void;
  setHasUnsavedSnippet: (hasUnsavedSnippet: boolean) => void;
  setIsCreatingCustomFiles: (isCreating: boolean) => void;
  showMain: () => void;
  toggle: () => void;
  viewStack: SettingsPanelView[];
}

export const useSettingsPanelStore = create<SettingsPanelStore>(set => ({
  hasUnsavedSnippet: false,
  isCreatingCustomFiles: false,
  isOpen: false,
  showMain: () => set({ viewStack: ROOT_VIEW_STACK }),
  viewStack: ROOT_VIEW_STACK,
  open: () => set({ isOpen: true }),
  setHasUnsavedSnippet: hasUnsavedSnippet => set({ hasUnsavedSnippet }),
  setIsCreatingCustomFiles: isCreatingCustomFiles =>
    set({ isCreatingCustomFiles }),
  close: () =>
    set(state =>
      state.isCreatingCustomFiles
        ? state
        : { isOpen: false, viewStack: ROOT_VIEW_STACK },
    ),
  toggle: () =>
    set(state =>
      state.isCreatingCustomFiles
        ? state
        : {
            isOpen: !state.isOpen,
            viewStack: state.isOpen ? ROOT_VIEW_STACK : state.viewStack,
          },
    ),
  push: view => set(state => ({ viewStack: [...state.viewStack, view] })),
  replace: view =>
    set(state => ({ viewStack: [...state.viewStack.slice(0, -1), view] })),
  back: () =>
    set(state =>
      !state.isCreatingCustomFiles && state.viewStack.length > 1
        ? { viewStack: state.viewStack.slice(0, -1) }
        : state,
    ),
}));

export const selectCurrentSettingsPanelView = (state: SettingsPanelStore) =>
  state.viewStack[state.viewStack.length - 1];
